import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import ProgramLogos from '../components/ProgramLogos';

const WidgetContainer = props => {
	return <ProgramLogos {...props} />;
};

WidgetContainer.defaultProps = {
	programLogos: [],
	dealerCode: ''
};

WidgetContainer.propTypes = {
	programLogos: PropTypes.arrayOf(PropTypes.string),
	dealerCode: PropTypes.string
};

const mapStateToProps = state => {
	return {
		dealerCode: state.dealerCode,
		programLogos: state.programLogos
	};
};

const Widget = connect(mapStateToProps, null)(WidgetContainer);

export default Widget;
